import { Injector, ɵsetCurrentInjector } from '@angular/core';

export function setCurrentInjector(injector: Injector) {
	ɵsetCurrentInjector(injector);
}
